import { Stack, Text } from "@fluentui/react";
import Box from "@mui/material/Box";
import Skeleton from "@mui/material/Skeleton";
import { animated, useSpring } from "@react-spring/web";
import styles from "./Answer.module.css";
import { AnswerIcon } from "./AnswerIcon";
import { Tab, Tabs } from "@mui/material";
import i18next from "../../i18n/i18n";
import { appInfo, userInfo } from "../../authConfig";
import React from "react";
import { QuestionDetails } from "../../api";
import { getAttachedFileLoadingMeta } from "./AttachmentLoadingMessage";

interface Props {
    selectedAppType: string;
    questionFilesAttached?: QuestionDetails["filesAttached"];
}

export const AnswerLoading = ({ selectedAppType, questionFilesAttached }: Props) => {
    const animatedStyles = useSpring({
        from: { opacity: 0 },
        to: { opacity: 1 }
    });
    const isWap = String(userInfo?.isWap).toLowerCase() === "true";
    const useAll = appInfo?.use_all_tab === true;
    const hideTabs = !isWap && useAll;
    const showAllTab = isWap && useAll;
    const attachedFileLoadingMeta = React.useMemo(() => getAttachedFileLoadingMeta(questionFilesAttached), [questionFilesAttached]);
    const animatedMessageCharacters = React.useMemo(() => Array.from(attachedFileLoadingMeta.message), [attachedFileLoadingMeta.message]);

    return (
        <animated.div style={{ ...animatedStyles }}>
            <Stack className={styles.answerContainer} style={{ display: "flex", flexDirection: "row" }} verticalAlign="center">
                <AnswerIcon
                    language={null}
                    sub_product={null}
                    product={null}
                    documenttype={null}
                    chatModel={null}
                    reasoningEffort={null}
                    feedbackCorpId={null}
                    feedbackUser={null}
                    CorpId={null}
                    UserId={null}
                    isFeedbackPage={false}
                    productVersion={null}
                    apptype={null}
                />
                <Stack.Item grow>
                    {hideTabs ? null : (
                        <Tabs className={styles.answerText} value={selectedAppType} aria-label="basic tabs example">
                            {showAllTab && <Tab label={i18next.t("chat.ALL")} value="ALL" className={styles["tab-root"]} />}
                            <Tab label={i18next.t("chat.faq")} value="FAQ" className={styles["tab-root"]} />
                            <Tab label={i18next.t("chat.manuals")} value="Manuals" className={styles["tab-root"]} />
                        </Tabs>
                    )}
                    <Box
                        sx={{
                            width: "100%",
                            marginTop: hideTabs ? "32px" : "0px"
                        }}
                    >
                        {attachedFileLoadingMeta.message && (
                            <Text
                                style={{ color: "#00000099", marginBottom: "4px" }}
                                title={attachedFileLoadingMeta.fileNames.length > 0 ? attachedFileLoadingMeta.fileNames.join(", ") : undefined}
                            >
                                <span className={styles.loadingLabelText}>
                                    {animatedMessageCharacters.map((character, index) => (
                                        <span
                                            key={`loading-letter-${index}`}
                                            className={styles.loadingLabelLetter}
                                            style={{ animationDelay: `${index * 0.035}s` }}
                                        >
                                            {character === " " ? "\u00A0" : character}
                                        </span>
                                    ))}
                                </span>
                            </Text>
                        )}
                        <Skeleton animation="wave" sx={{ width: "100%" }} />
                        <Skeleton animation="wave" sx={{ width: "90%" }} />
                        <Skeleton animation="wave" sx={{ width: "80%" }} />
                        <Skeleton animation="wave" sx={{ width: "70%" }} />
                        <Skeleton animation="wave" sx={{ width: "60%" }} />
                        <Skeleton animation="wave" sx={{ width: "50%" }} />
                    </Box>
                </Stack.Item>
            </Stack>
        </animated.div>
    );
};
